import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { FiCalendar } from "react-icons/fi";
import ScheduleHistory from "../../components/AiChatComponent/panelComponents/ScheduleHistory";
import { setModalState, modalViewsConst } from "../../store/modalSlice";
import type { ScheduleOccurrence } from "../../utils/scheduleTransform";
import type { AppDispatch } from "../../store";

interface SchedulesWidgetProps {
  projectId: string;
  projectTitle: string;
}

const SchedulesWidget: React.FC<SchedulesWidgetProps> = ({ projectId, projectTitle }) => {
  const dispatch = useDispatch<AppDispatch>();

  // A schedule occurrence's id IS its conversationId — open it in the shared chat modal
  // so results render with the same rich pipeline (maps, reasoning) as chat history.
  const handleResultSelect = useCallback(
    (_item: unknown, _question: unknown, occurrence: ScheduleOccurrence) => {
      if (!occurrence.id) return;
      dispatch(setModalState({
        modalOpen: true,
        modalView: modalViewsConst.projectChat,
        properties: { __modalSize: "2xl", projectId, projectTitle, initialConversationId: occurrence.id },
      }));
    },
    [dispatch, projectId, projectTitle]
  );

  return (
    <div className="border border-gray-200 rounded-md flex flex-col overflow-hidden h-[36rem] lg:h-auto lg:min-h-0">
      <div className="flex-none flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div className="text-sm font-semibold text-gray-700 flex items-center gap-2">
          <FiCalendar className="w-4 h-4 text-eai-primary-accent" />
          Agents
        </div>
        <button
          onClick={() => dispatch(setModalState({ modalOpen: true, modalView: modalViewsConst.createSchedule, properties: { projectId } }))}
          className="eai-btn-grn text-sm"
        >
          + New Agent
        </button>
      </div>
      <div className="flex-1 min-h-0 flex flex-col">
        <ScheduleHistory onResultSelect={handleResultSelect} projectId={projectId} hideNewButton />
      </div>
    </div>
  );
};

export default SchedulesWidget;
